import React from "react";
import {
  FaReact,
  FaHandPointRight,
  FaDatabase,
  FaMapMarkerAlt,
  FaEnvelope,
  FaDownload,
  FaPhoneAlt,
  FaNodeJs,
  FaTools,
} from "react-icons/fa";

const data = {
  homeDetails:
    "Développeur Full Stack passionné par la création d'applications web et mobiles modernes et performantes.",
  homeTitle: "Bienvenue sur mon portfolio personnel",
  projectTitle: "Projets",
  projectCategories: ["Tous", "Full-Stack", "Frontend", "Mobile", "API"],
  projectShowMore: "Voir plus de projets",
  projectShowLess: "Réduire",
  technoTitle: "Technologies",
  download: <FaDownload aria-hidden="true" />,
  technoInfo:
    "Je dispose d'un large éventail de compétences full stack — du développement d'interfaces React/Next.js à la création d'APIs scalables avec Node.js, NestJS et FastAPI, supportées par des bases de données SQL et NoSQL.",
  titleAbout: "À propos de moi",
  infoAbout:
    "Je suis Mwafrika Josué, Développeur Full Stack spécialisé dans les technologies web modernes. Je crée des applications web, des plateformes SaaS et des APIs pour les entreprises. J'aime résoudre des défis techniques complexes et élargir continuellement mes compétences.",
  experienceTitle: "Expérience",
  experienceInfo:
    "Un aperçu de mon parcours professionnel — entre équipes distribuées en remote, missions sur site et mentorat bénévole.",
  experience: [
    {
      id: 1,
      role: "Développeur Full-Stack",
      company: "Consumatech Solutions",
      period: "sept. 2022 – avr. 2024, juil. 2026 – Présent",
      location: "Le Cap, Afrique du Sud (Remote)",
      impact:
        "Développe Cashout Live, un jeu-questionnaire mobile pour MTN Nigeria — PWA hors-ligne pour les joueurs, suite de diffusion en direct et canal USSD/SMS, avec NestJS, PostgreSQL et Redis.",
    },
    {
      id: 2,
      role: "Développeur Mid-Senior",
      company: "byFood",
      period: "juil. 2024 – 2025",
      location: "Tokyo, Japon (Remote)",
      impact:
        "Fonctionnalités full-stack en Go et Next.js/TypeScript pour une plateforme food & travel, avec optimisation SEO pour la visibilité organique.",
    },
    {
      id: 3,
      role: "Développeur Mid-Senior",
      company: "Rabsh Stability",
      period: "2025 – juin 2026",
      location: "Kinshasa, RDC (Sur site)",
      impact:
        "Conception et fiabilisation d'APIs Node.js/Express sur PostgreSQL, avec un accent sur la performance, la sécurité et l'intégration aux données relationnelles.",
    },
    {
      id: 4,
      role: "Mentor (Bénévole)",
      company: "Microverse",
      period: "févr. 2020 – juil. 2022",
      location: "Remote",
      impact:
        "Mentorat de plus de 5 développeurs juniors, réduisant les erreurs de code d'environ 20% et améliorant la qualité du code par le pair programming.",
    },
  ],
  imageAbout:
    "https://res.cloudinary.com/ujuzi/image/upload/v1653783195/mes%20documents/IMG_4892_gqppaj.jpg",
  cards: [
    {
      id: 1,
      category: "Full-Stack",
      image: "/images/cashout-player.jpg",
      alt: "Écran d'accueil de la PWA joueur Cashout Live montrant le quiz quotidien de 10 questions et le tableau de points",
      title: "Cashout Live — Application joueur",
      technologies: ["Next.js 15", "React 19", "PWA", "IndexedDB", "Authentification MSISDN"],
      info: "Cashout Live est un jeu-questionnaire mobile lancé avec MTN Nigeria : les abonnés reçoivent chaque jour un nombre défini de questions, gagnent des points pour les bonnes réponses et grimpent dans un classement pour remporter des prix journaliers, hebdomadaires et mensuels — avec la possibilité d'acheter des questions supplémentaires une fois le quota quotidien épuisé. Voici l'application web progressive (PWA) destinée aux joueurs : installable, fonctionnelle hors-ligne et authentifiée par numéro de téléphone.",
      live: "https://staging.cashoutlive.ng/know",
    },
    {
      id: 2,
      category: "Frontend",
      image: "/images/cashout-gameshow.jpg",
      alt: "Cashout Live Game Show - page d'accueil avec nombre de spectateurs en direct et cagnotte",
      title: "Cashout Live — Émission en direct",
      technologies: ["Next.js", "React", "BroadcastChannel", "Tailwind CSS"],
      info: "Le volet jeu-questionnaire en direct de Cashout Live, où les meilleurs joueurs s'affrontent en tête-à-tête en temps réel — animé par un présentateur en direct et suivi par des spectateurs. Construit comme une seule base de code Next.js réunissant Console Animateur, Candidat, Spectateur et un écran de diffusion, synchronisés entre onglets pour faire tourner toute l'émission depuis une seule machine.",
      live: "https://staging-game-show.cashoutlive.ng/",
    },
    {
      id: 3,
      category: "Frontend",
      image: "/images/cashout-ussd.jpg",
      alt: "Simulateur téléphone basique Cashout Live montrant un menu USSD du jeu sur MTN",
      title: "Cashout Live — Simulateur USSD/SMS",
      technologies: ["Next.js", "React", "USSD", "Passerelle SMS"],
      info: "Un canal pour téléphones basiques de Cashout Live, apportant le jeu-questionnaire quotidien — abonnement, réponse aux questions, consultation des points et du classement — aux abonnés MTN sans smartphone, via USSD et SMS.",
      live: "https://staging-ussd-simulator.cashoutlive.ng/simulator",
    },
    {
      id: 4,
      category: "Full-Stack",
      image: "/images/cawi.jpg",
      alt: "CAWI - Plateforme de l'organisation Congo Animal Welfare Initiative, page campagnes",
      title: "CAWI",
      technologies: ["Next.js", "TypeScript", "next-intl", "TanStack Query", "Express", "Prisma"],
      info: "Une plateforme bilingue pour le Congo Animal Welfare Initiative, une organisation à but non lucratif qui protège les animaux en RD Congo. Elle propose des programmes, campagnes, actualités, un parcours de don en ligne et un portail d'administration, construite avec Next.js côté frontend et une API Express/Prisma/PostgreSQL.",
      code: "https://github.com/mwafrika/cawi-congo",
      live: "https://congoanimalwelfareinitiative.com/",
    },
    {
      id: 5,
      category: "Full-Stack",
      image: "/images/ilovecv.jpg",
      alt: "ILoveCV - Page d'accueil du créateur de CV propulsé par l'IA",
      title: "ILoveCV",
      technologies: ["Next.js", "TypeScript", "Supabase", "Gemini AI", "Zustand", "next-intl"],
      info: "Un créateur de CV propulsé par l'IA qui permet de concevoir des CV soignés et compatibles ATS grâce à l'édition par glisser-déposer, des modèles premium, des suggestions de contenu via Gemini et un export PDF en un clic. Construit avec Next.js, Supabase pour l'authentification/le stockage, et next-intl pour le support bilingue.",
      code: "https://github.com/mwafrika/MakeMyCV",
      live: "https://make-my-cv-eight.vercel.app/",
    },
    {
      id: 6,
      category: "Frontend",
      image:
        "https://i.ibb.co/BK1Hn0x/Screenshot-2022-08-08-at-4-05-48-PM.png",
      alt: "Page de destination moderne avec section héros et fonctionnalités",
      title: "Page de destination moderne",
      technologies: ["React", "Tailwind CSS", "Vite"],
      info: "Un site web marketing moderne construit avec React, TailwindCSS et Vite — rapide, responsive et prêt pour la production.",
      code: "https://github.com/mwafrika/Modern-landing-page",
      live: "https://modern-landing-page2.netlify.app/",
    },
    {
      id: 7,
      category: "Frontend",
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650092446/portfolio_images/FireShot_Capture_008_-_CMS_Blog_-_blog-with-cms.vercel.app_w3pkph.png",
      alt: "Application de blog GraphCMS avec articles en vedette",
      title: "Blog GraphCMS",
      technologies: ["Next.js", "Tailwind CSS", "GraphQL", "GraphCMS"],
      info: "Un blog CMS entièrement responsive avec articles Markdown, informations auteur, commentaires et catégories.",
      code: "https://github.com/mwafrika/GraphCMS-Blog",
      live: "https://blog-with-cms.vercel.app/",
    },
    {
      id: 8,
      category: "Mobile",
      image: "/images/chuck-norris.jpg",
      alt: "Écran de l'application mobile Chuck Norris",
      title: "Chuck Norris App",
      technologies: ["React Native", "TypeScript", "Styled-components"],
      info: "Une application mobile affichant des blagues aléatoires de Chuck Norris par catégorie, développée avec React Native et TypeScript.",
      code: "https://github.com/mwafrika/chuck-test-sovetech",
      live: "https://res.cloudinary.com/ujuzi/video/upload/v1660853712/XRecorder_18082022_215959_lrkth0.mp4",
    },

    {
      id: 9,
      category: "Full-Stack",
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1670286381/Kevent/huntify_iw4jnf.png",
      alt: "Tableau de bord de l'application Huntify de suivi des candidatures",
      title: "Huntify",
      technologies: ["MERN Stack", "Context API", "Styled-components"],
      info: "Huntify suit vos candidatures d'emploi et organise votre recherche, le tout en un seul endroit. Fini les tableurs et les candidatures perdues.",
      code: "https://github.com/mwafrika/jobifyMev2",
      live: "https://huntify.netlify.app",
    },

  ],
  technologies: [
    {
      id: 1,
      icon: <FaReact className="text-[#61DAFB] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Frontend",
      list: [
        "React / React Native",
        "Next.js",
        "TypeScript",
        "Redux / Zustand",
        "Tailwind CSS",
        "HTML5 & CSS3",
      ],
    },
    {
      id: 2,
      icon: <FaNodeJs className="text-[#68A063] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Backend",
      list: [
        "Node.js / Express",
        "NestJS",
        "FastAPI (Python)",
        "Ruby on Rails",
        "REST APIs",
        "Celery & Redis",
      ],
    },
    {
      id: 3,
      icon: <FaDatabase className="text-[#336791] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Base de données & ORM",
      list: [
        "PostgreSQL",
        "MySQL / MongoDB",
        "Prisma / TypeORM",
        "Sequelize",
        "Redis",
      ],
    },
    {
      id: 4,
      icon: <FaTools className="text-[#f97316] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "DevOps & Outils",
      list: [
        "Docker & Docker Compose",
        "Git & GitHub",
        "CI/CD (GitHub Actions)",
        "Vercel / Netlify / DigitalOcean",
        "Jest / Mocha / Chai",
        "Postman / Swagger",
      ],
    },
  ],
  contact: {
    title: "Contactez-moi",
    subTitle: "Entrons en contact",
    info: "Je suis toujours ouvert à de nouvelles opportunités et collaborations. Si vous avez un projet en tête ou souhaitez simplement échanger, n'hésitez pas à me contacter.",
    list: [
      {
        id: 1,
        icon: <FaMapMarkerAlt className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "Kigali, Rwanda",
      },
      {
        id: 2,
        icon: <FaEnvelope className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "mwafrikajosue@gmail.com",
        href: "mailto:mwafrikajosue@gmail.com",
      },
      {
        id: 3,
        icon: <FaPhoneAlt className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "(+243) 995 220 038",
        href: "tel:+243995220038",
      },
    ],
  },
  menu: [
    { id: 1, name: "Accueil", url: "/#home" },
    { id: 2, name: "À propos", url: "/#about" },
    { id: 3, name: "Projets", url: "/#projects" },
    { id: 4, name: "Compétences", url: "/#tech" },
    { id: 5, name: "Expérience", url: "/#experience" },
    { id: 6, name: "Contact", url: "/#contact" },
  ],
};

export default data;
